"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPClient = void 0;
var isAuthorizationHeaderValid = function (authorizationHeader) {
    var valid = false;
    var tokenString;
    if (authorizationHeader && authorizationHeader.Authorization) {
        // validate the expiration
        var token = null;
        try {
            var parts = authorizationHeader.Authorization.split('.');
            tokenString = window.atob(parts[1]);
            token = JSON.parse(tokenString);
        }
        catch (error) {
            // tslint:disable-next-line
            console.error('invalid token structure', tokenString);
        }
        if (token !== null && token.exp && token.exp * 1000 > Date.now()) {
            valid = true;
        }
    }
    return valid;
};
var HTTPClient = /** @class */ (function () {
    function HTTPClient(authenticationUrl, authenticationHeaders) {
        this.authenticationUrl = authenticationUrl;
        this.authenticationHeaders = authenticationHeaders;
        this.authorizationHeader = null;
        this.authenticationUrl = authenticationUrl;
        this.authenticationHeaders = authenticationHeaders;
    }
    HTTPClient.prototype._request = function (httpMethod, url, params, token, callback, noRetry) {
        var _this = this;
        if (noRetry === void 0) { noRetry = false; }
        this.getAuthorizationHeader().then(function (header) {
            var request = new XMLHttpRequest();
            var queryString = '';
            var body = '';
            switch (httpMethod) {
                case 'POST':
                case 'PUT':
                    body = JSON.stringify(params);
                    break;
                default:
                    queryString = '';
                    for (var key in params) {
                        if (typeof params[key] === 'function' ||
                            params[key] === null ||
                            params[key] === undefined) {
                            continue;
                        }
                        if (queryString !== '') {
                            queryString += '&';
                        }
                        queryString += key + '=' + encodeURIComponent(params[key]);
                    }
            }
            request.addEventListener('load', function (event) {
                var payload = null;
                try {
                    // TODO: fix, '{}' is temporary solution
                    payload = JSON.parse(request.responseText || '{}');
                }
                catch (error) {
                    callback(error, null);
                    return;
                }
                if (!(request.status === 200 || request.status === 201)) {
                    if (request.status === 401 && !noRetry) {
                        _this._request(httpMethod, url, params, token, callback, true);
                        return;
                    }
                    callback(payload, null);
                    return;
                }
                callback(null, payload);
            });
            request.addEventListener('error', function (event) {
                if (request.status === 403 || request.status === 401) {
                    _this.authorizationHeader = null;
                    if (request.status === 401 && !noRetry) {
                        _this._request(httpMethod, url, params, token, callback, true);
                        return;
                    }
                }
                callback(new Error(request.statusText), null);
            });
            request.addEventListener('abort', function (event) {
                callback(new Error(request.statusText), null);
            });
            request.open(httpMethod, queryString ? url + '?' + queryString : url);
            request.withCredentials = true;
            request.setRequestHeader('Accept', 'application/json');
            request.setRequestHeader('Content-Type', 'application/json');
            request.setRequestHeader('Authorization', header.Authorization);
            request.send(body);
        }, function (error) {
            if (callback) {
                callback(error, null);
            }
            return Promise.reject(error);
        });
    };
    HTTPClient.prototype.getAuthorizationHeader = function () {
        var _this = this;
        var authorizationHeader = this.authorizationHeader;
        if (isAuthorizationHeaderValid(authorizationHeader)) {
            return Promise.resolve(authorizationHeader);
        }
        return new Promise(function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.addEventListener('load', function () {
                try {
                    // TODO: fix, '{}' is temporary solution
                    _this.authorizationHeader = JSON.parse(request.responseText || '{}');
                }
                catch (error) {
                    return reject(error);
                }
                return resolve(_this.authorizationHeader);
            });
            request.addEventListener('error', function () {
                reject(new Error(request.statusText));
            });
            request.addEventListener('abort', function () {
                reject(new Error(request.statusText));
            });
            request.open('GET', _this.authenticationUrl);
            request.withCredentials = true;
            request.setRequestHeader('Accept', 'application/json');
            if (_this.authenticationHeaders) {
                _this.authenticationHeaders.forEach(function (value, key) {
                    return request.setRequestHeader(key, value);
                });
            }
            request.send();
        });
    };
    /**
     * @description deletes the cached authorization header
     */
    HTTPClient.prototype.deauthorize = function () {
        this.authorizationHeader = null;
    };
    HTTPClient.prototype.get = function (url, params, token) {
        var _this = this;
        if (params === void 0) { params = {}; }
        return new Promise(function (resolve, reject) {
            _this._request('GET', url, params, token, function (error, response) {
                if (error) {
                    reject(error);
                }
                else {
                    resolve(response);
                }
            });
        });
    };
    HTTPClient.prototype.put = function (url, params, token) {
        var _this = this;
        if (params === void 0) { params = {}; }
        return new Promise(function (resolve, reject) {
            _this._request('PUT', url, params, token, function (error, response) {
                if (error) {
                    reject(error);
                }
                else {
                    resolve(response);
                }
            });
        });
    };
    HTTPClient.prototype.post = function (url, params, token) {
        var _this = this;
        if (params === void 0) { params = {}; }
        return new Promise(function (resolve, reject) {
            _this._request('POST', url, params, token, function (error, response) {
                if (error) {
                    reject(error);
                }
                else {
                    resolve(response);
                }
            });
        });
    };
    HTTPClient.prototype.delete = function (url, params, token) {
        var _this = this;
        if (params === void 0) { params = {}; }
        return new Promise(function (resolve, reject) {
            _this._request('DELETE', url, params, token, function (error, response) {
                if (error) {
                    reject(error);
                }
                else {
                    resolve(response);
                }
            });
        });
    };
    HTTPClient.prototype.addAuthToUrl = function (url) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var parsedUrl_1 = new URL(url);
                _this.getAuthorizationHeader().then(function (header) {
                    parsedUrl_1.searchParams.set('Authorization', header.Authorization);
                    resolve(parsedUrl_1.toString());
                }, function (e) {
                    reject(e);
                });
            }
            catch (e) {
                reject(e);
            }
        });
    };
    return HTTPClient;
}());
exports.HTTPClient = HTTPClient;
//# sourceMappingURL=browser-http-client.js.map